// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Container, ImageSection, FormSection, Title } from './Login.style';
import { LoginForm } from './components';

type Props = {};
export type StateType = {
  setErrorMessage: String,
  user: Object,
  isAuthenticated: Boolean,
};
export type DispatchPropsType = {
  login: Function,
};

class LoginPage extends Component<Props & StateType & DispatchPropsType> {
  componentDidMount() {
    const { isAuthenticated } = this.props;
    if (isAuthenticated) {
      const { history } = this.props;
      // history.replace('/');
    }
  }

  componentDidUpdate(prevProps: Props & StateType & DispatchPropsType) {
    if (prevProps.isAuthenticated !== this.props.isAuthenticated) {
      const { user, isAuthenticated } = this.props;
      if (isAuthenticated && user && user.role) {
        const { history } = this.props;
        // history.push('/');
      }
    }
  }

  render(): React$Element<any> {
    const { setErrorMessage, login } = this.props;
    return (
      <div>
        <div className="pt-32pt">
          <div className="container page__container d-flex flex-column flex-md-row align-items-center text-center text-sm-left">
            <div className="flex align-items-center mb-24pt mb-md-0">
              <div className="mb-24pt mb-sm-0 mr-sm-24pt">
                <h1 className="mb-0 text-center">Welcome to TACS</h1>
                <h3 className="mb-0 text-center">(Truck Access Control System)</h3>
              </div>
            </div>
          </div>
        </div>
        <Container>
          <FormSection>
            <div className="row mb-32pt">
              <div className="col-lg-4">
                <Title>
                  <div className="page-separator">
                    <div className="page-separator__text">Sign In</div>
                  </div>
                </Title>
                <LoginForm loginRequest={login} setErrorMessage={setErrorMessage} />
              </div>
              <ImageSection />
            </div>
          </FormSection>
        </Container>
      </div>
    );
  }
}

export default withRouter(LoginPage);
